import { render, staticRenderFns } from "./TakeOrder.vue?vue&type=template&id=aafa0fee&scoped=true&"
import script from "./TakeOrder.vue?vue&type=script&lang=js&"
export * from "./TakeOrder.vue?vue&type=script&lang=js&"
import style0 from "./TakeOrder.vue?vue&type=style&index=0&id=aafa0fee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aafa0fee",
  null
  
)

export default component.exports